import { CreditsActionTypes } from "./creditsTypes";
const initialState = {
    list: []
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case CreditsActionTypes.FETCH_CREDITS_SUCCESS:
            return Object.assign(Object.assign({}, state), { list: action.payload });
        default:
            return state;
    }
};
export { reducer as creditsReducer };
